import { getContext } from '@fiverr-private/fiverr_context';
import { inExperiment } from '../experiments';
import { LYNXES_LOHP_CLEAN_PAGE } from '../experiments/experimentsEnum';

export const inCleanPageTest = () => {
    const { abTests } = getContext();

    return inExperiment(LYNXES_LOHP_CLEAN_PAGE, abTests);
};
